import { Injectable } from '@angular/core';
import { AlertController } from 'ionic-angular';
import { Validator } from '../validator';
import { Settings } from '../settings';
import { LogoutProvider } from './logout';

const errorMessages = {
  // Alert Provider
  // This is the provider class for most of the success and error messages in the app.
  // If you added your own messages don't forget to make a function for them or add them in the showErrorMessage switch block.

    // Firebase Error Messages
    accountExistsWithDifferentCredential: { title: 'Konto bereits vorhanden!', subTitle: 'Ein Konto mit den gleichen Anmeldedaten ist bereits vorhanden.' },
    invalidCredential: { title: 'Ungültige Anmeldedaten!', subTitle: 'Es ist ein Fehler bei der Anmeldung mit diesen Anmeldedaten aufgetreten.' },
    invalidPhoneserial: { title: 'Ungültiges Smartphone', subTitle: 'Der Account wurde mit einem anderen Smartphone verknüpft, bitte melde dich bei einem Administrator' },
    codeUpdated: { title: 'Identifizierung', subTitle: 'Ihr Smartphone wurde neu mit ihren Account verknüpft. Sie können sich jetzt wieder wie gewohnt anmelden.' },
    operationNotAllowed: { title: 'Anmelden fehlgeschlagen!', subTitle: 'Das Einloggen bei diesem Anbieter ist nicht erlaubt! Bitte wende Dich an den Support.' },
    userDisabled: { title: 'Konto deaktiviert!', subTitle: 'Es tut uns Leid! Aber dieses Konto wurde gesperrt! Bitte wende Dich an den Support.' },
    userNotFound: { title: 'Konto nicht gefunden!', subTitle: 'Es tut uns Leid, aber ein Konto mit diesen Anmeldedaten konnte nicht gefunden werden.' },
    wrongPassword: { title: 'Passwort falsch!', subTitle: 'Es tut uns leid, aber das von Dir eingegebene Passwort ist falsch.' },
    invalidEmail: { title: 'Ungültige E-Mail!', subTitle: 'Es tut uns leid, aber die E-Mail-Adresse ist ungültig/nicht vorhanden.' },
    emailAlreadyInUse: { title: 'E-Mail nicht verfügbar!', subTitle: 'Es tut uns Leid, aber diese E-Mail wird bereits verwendet.' },
    weakPassword: { title: 'Schwaches Passwort!', subTitle: 'Es tut uns leid, aber das Passwort ist zu schwach.' },
    requiresRecentLogin: { title: 'Berechtigung abgelaufen!', subTitle: 'Es tut uns Leid, aber diese Anmeldedaten sind abgelaufen! Bitte melde Dich erneut an.' },
    userMismatch: { title: 'Benutzer stimmt nicht überein!', subTitle: ' Es tut uns Leid, aber diese Anmeldedaten sind bereits vergeben!' },
    providerAlreadyLinked: { title: 'Bereits verknüpft!', subTitle: 'Es tut uns Leid, aber diese Anmeldedaten sind bereits mit einem anderem Konto verknüpft.' },
    credentialAlreadyInUse: { title: 'Anmeldedaten nicht verfügbar', subTitle: 'Es tut uns leid, aber diese Anmeldedaten werden bereits von einem anderen Benutzer verwendet.' },

    // Profile Error Messages
    changeName: { title: 'Namensänderung fehlgeschlagen!', subTitle: 'Es tut uns Leid, aber wir haben einen Fehler bei der Änderung des Namens festgestellt.' },
    invalidCharsName: Validator.profileNameValidator.patternError,
    nameTooShort: Validator.profileNameValidator.lengthError,
    changeEmail: { title: 'E-Mail ändern fehlgeschlagen', subTitle: 'Es tut uns Leid, aber wir haben einen Fehler bei der Änderung der E-Mail-Adresse festgestellt.' },
    invalidProfileEmail: Validator.profileEmailValidator.patternError,
    changePhoto: { title: 'Foto ändern fehlgeschlagen!', subTitle: 'Es tut uns Leid, aber wir haben einen Fehler beim Ändern des Fotos festgestellt.' },
    passwordTooShort: Validator.profilePasswordValidator.lengthError,
    invalidCharsPassword: Validator.profilePasswordValidator.patternError,
    passwordsDoNotMatch: { title: 'Passwort ändern fehlgeschlagen!', subTitle: 'Es tut uns Leid, aber die von Dir eingegebenen Passwörter stimmen nicht überein.' },
    updateProfile: { title: 'Profil aktualisieren fehlgeschlagen', subTitle: 'Es tut uns Leid, aber wir haben einen Fehler bei der Aktualisierung des Profils festgestellt.' },
    usernameExists: { title: 'Benutzername bereits vorhanden!', subTitle: 'Es tut uns Leid, aber dieser Benutzername ist bereits von einem anderen Benutzer vergeben.' },
    // Image Error Messages
    imageUpload: { title: 'Bild hochladen fehlgeschlagen!', subTitle: ' Es tut uns Leid, aber wir haben einen Fehler beim Hochladen des ausgewählten Bildes festgestellt.' },
    // Group Error Messages
    groupUpdate: { title: 'Gruppe aktualisieren fehlgeschlagen!', subTitle: 'Es tut uns Leid, aber wir haben einen Fehler beim Aktualisieren dieser Gruppe festgestellt.' },
    groupLeave: { title: ' Gruppe verlassen fehlgeschlagen!', subTitle: ' Es tut uns Leid, beim Verlassen dieser Gruppe ist ein Fehler aufgetreten.' },
    groupDelete: { title: 'Gruppe löschen fehlgeschlagen!', subTitle: ' Es tut uns Leid, aber es ist ein Fehler beim Löschen dieser Gruppe aufgetreten.' }
};

const successMessages = {
    passwordResetSent: { title: 'Passwort zurücksetzen gesendet!', subTitle: 'Eine E-Mail zum Zurücksetzen des Passworts wurde gesendet an: ' },
    profileUpdated: { title: 'Profil aktualisiert!', subTitle: ' Das Profil wurde erfolgreich aktualisiert!' },
    emailVerified: { title: 'E-Mail bestätigt!', subTitle: 'Herzlichen Glückwunsch! Die E-Mail wurde bestätigt!' },
    emailVerificationSent: { title: 'E-Mail-Bestätigung gesendet!', subTitle: 'Eine E-Mail-Bestätigung wurde gesendet an: ' },
    accountDeleted: { title: 'Konto gelöscht!', subTitle: ' Das Konto wurde erfolgreich gelöscht.' },
    passwordChanged: { title: 'Passwort geändert!', subTitle: 'Das Passwort wurde erfolgreich geändert.' },
    friendRequestSent: { title: 'Freundschaftsanfrage gesendet!', subTitle: 'Die Freundschaftsanfrage wurde erfolgreich gesendet!' },
    friendRequestRemoved: { title: 'Freundschaftsanfrage gelöscht!', subTitle: 'Die Freundschaftsanfrage wurde erfolgreich gelöscht.' },
    groupUpdated: { title: 'Gruppe aktualisiert!', subTitle: 'Diese Gruppe wurde erfolgreich aktualisiert!' },
    groupLeft: { title: 'Gruppe verlassen', subTitle: 'Gruppe erfolgreich verlassen' }
};

@Injectable()
export class AlertProvider {
  private alert;

  constructor(public alertCtrl: AlertController, public logoutProvider: LogoutProvider) {
    console.log("Initializing Alert Provider");
  }

  // Show profile updated
  showProfileUpdatedMessage() {
    this.alert = this.alertCtrl.create({
      title: successMessages.profileUpdated["title"],
      subTitle: successMessages.profileUpdated["subTitle"],
      buttons: ['OK']
    }).present();
  }

  // Show password reset sent
  showPasswordResetMessage(email) {
    this.alert = this.alertCtrl.create({
      title: successMessages.passwordResetSent["title"],
      subTitle: successMessages.passwordResetSent["subTitle"] + email,
      buttons: ['OK']
    }).present();
  }

  // Show email verified and redirect to homePage
  showEmailVerifiedMessageAndRedirect(navCtrl) {
    this.alert = this.alertCtrl.create({
      title: successMessages.emailVerified["title"],
      subTitle: successMessages.emailVerified["subTitle"],
      buttons: [{
        text: 'OK',
        handler: () => {
          navCtrl.setRoot(Settings.homePage);
        }
      }]
    }).present();
  }

  // Show email verification sent
  showEmailVerificationSentMessage(email) {
    this.alert = this.alertCtrl.create({
      title: successMessages.emailVerificationSent["title"],
      subTitle: successMessages.emailVerificationSent["subTitle"] + email,
      buttons: ['OK']
    }).present();
  }

  // Show account deleted
  showAccountDeletedMessage() {
    this.alert = this.alertCtrl.create({
      title: successMessages.accountDeleted["title"],
      subTitle: successMessages.accountDeleted["subTitle"],
      buttons: ['OK']
    }).present();
  }

  // Show password changed
  showPasswordChangedMessage() {
    this.alert = this.alertCtrl.create({
      title: successMessages.passwordChanged["title"],
      subTitle: successMessages.passwordChanged["subTitle"],
      buttons: ['OK']
    }).present();
  }

  // Show friend request sent
  showFriendRequestSent() {
    this.alert = this.alertCtrl.create({
      title: successMessages.friendRequestSent["title"],
      subTitle: successMessages.friendRequestSent["subTitle"],
      buttons: ['OK']
    }).present();
  }

  // Show friend request removed
  showFriendRequestRemoved() {
    this.alert = this.alertCtrl.create({
      title: successMessages.friendRequestRemoved["title"],
      subTitle: successMessages.friendRequestRemoved["subTitle"],
      buttons: ['OK']
    }).present();
  }

  // Show group updated.
  showGroupUpdatedMessage() {
    this.alert = this.alertCtrl.create({
      title: successMessages.groupUpdated["title"],
      subTitle: successMessages.groupUpdated["subTitle"],
      buttons: ['OK']
    }).present();
  }

  // Show error messages depending on the code
  // If you added custom error codes on top, make sure to add a case block for it.
  showErrorMessage(code) {
    switch (code) {
      // Firebase Error Messages
      case 'auth/account-exists-with-different-credential':
        this.alert = this.alertCtrl.create({
          title: errorMessages.accountExistsWithDifferentCredential["title"],
          subTitle: errorMessages.accountExistsWithDifferentCredential["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'auth/invalid-credential':
        this.alert = this.alertCtrl.create({
          title: errorMessages.invalidCredential["title"],
          subTitle: errorMessages.invalidCredential["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'auth/invalid-phoneserial':
          this.alert = this.alertCtrl.create({
              title: errorMessages.invalidPhoneserial["title"],
              subTitle: errorMessages.invalidPhoneserial["subTitle"],
              buttons: ['OK']
          }).present();
          break;
      case 'auth/code-updated':
        this.alert = this.alertCtrl.create({
            title: errorMessages.codeUpdated["title"],
            subTitle: errorMessages.codeUpdated["subTitle"],
            buttons: ['OK']
        }).present();
        break;
      case 'auth/operation-not-allowed':
        this.alert = this.alertCtrl.create({
          title: errorMessages.operationNotAllowed["title"],
          subTitle: errorMessages.operationNotAllowed["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'auth/popup-closed-by-user':
        this.alert = this.alertCtrl.create({
          title: errorMessages.operationNotAllowed["title"],
          subTitle: errorMessages.operationNotAllowed["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'auth/user-disabled':
        this.alert = this.alertCtrl.create({
          title: errorMessages.userDisabled["title"],
          subTitle: errorMessages.userDisabled["subTitle"],
          buttons: ['OK']
        });
        this.alert.present();
        break;
      case 'auth/user-not-found':
        this.alert = this.alertCtrl.create({
          title: errorMessages.userNotFound["title"],
          subTitle: errorMessages.userNotFound["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'auth/wrong-password':
        this.alert = this.alertCtrl.create({
          title: errorMessages.wrongPassword["title"],
          subTitle: errorMessages.wrongPassword["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'auth/invalid-email':
        this.alert = this.alertCtrl.create({
          title: errorMessages.invalidEmail["title"],
          subTitle: errorMessages.invalidEmail["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'auth/email-already-in-use':
        this.alert = this.alertCtrl.create({
          title: errorMessages.emailAlreadyInUse["title"],
          subTitle: errorMessages.emailAlreadyInUse["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'auth/weak-password':
        this.alert = this.alertCtrl.create({
          title: errorMessages.weakPassword["title"],
          subTitle: errorMessages.weakPassword["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'auth/requires-recent-login':
        this.alert = this.alertCtrl.create({
          title: errorMessages.requiresRecentLogin["title"],
          subTitle: errorMessages.requiresRecentLogin["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'auth/user-mismatch':
        this.alert = this.alertCtrl.create({
          title: errorMessages.userMismatch["title"],
          subTitle: errorMessages.userMismatch["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'auth/provider-already-linked':
        this.alert = this.alertCtrl.create({
          title: errorMessages.providerAlreadyLinked["title"],
          subTitle: errorMessages.providerAlreadyLinked["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'auth/credential-already-in-use':
        this.alert = this.alertCtrl.create({
          title: errorMessages.credentialAlreadyInUse["title"],
          subTitle: errorMessages.credentialAlreadyInUse["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      // Profile Error Messages
      case 'profile/error-change-name':
        this.alert = this.alertCtrl.create({
          title: errorMessages.changeName["title"],
          subTitle: errorMessages.changeName["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'profile/invalid-chars-name':
        this.alert = this.alertCtrl.create({
          title: errorMessages.invalidCharsName["title"],
          subTitle: errorMessages.invalidCharsName["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'profile/name-too-short':
        this.alert = this.alertCtrl.create({
          title: errorMessages.nameTooShort["title"],
          subTitle: errorMessages.nameTooShort["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'profile/error-change-email':
        this.alert = this.alertCtrl.create({
          title: errorMessages.changeEmail["title"],
          subTitle: errorMessages.changeEmail["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'profile/invalid-email':
        this.alert = this.alertCtrl.create({
          title: errorMessages.invalidProfileEmail["title"],
          subTitle: errorMessages.invalidProfileEmail["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'profile/error-change-photo':
        this.alert = this.alertCtrl.create({
          title: errorMessages.changePhoto["title"],
          subTitle: errorMessages.changePhoto["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'profile/password-too-short':
        this.alert = this.alertCtrl.create({
          title: errorMessages.passwordTooShort["title"],
          subTitle: errorMessages.passwordTooShort["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'profile/invalid-chars-password':
        this.alert = this.alertCtrl.create({
          title: errorMessages.invalidCharsPassword["title"],
          subTitle: errorMessages.invalidCharsPassword["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'profile/passwords-do-not-match':
        this.alert = this.alertCtrl.create({
          title: errorMessages.passwordsDoNotMatch["title"],
          subTitle: errorMessages.passwordsDoNotMatch["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'profile/error-update-profile':
        this.alert = this.alertCtrl.create({
          title: errorMessages.updateProfile["title"],
          subTitle: errorMessages.updateProfile["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'profile/error-same-username':
        this.alert = this.alertCtrl.create({
          title: errorMessages.usernameExists["title"],
          subTitle: errorMessages.usernameExists["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      //Image Error Messages
      case 'image/error-image-upload':
        this.alert = this.alertCtrl.create({
          title: errorMessages.imageUpload["title"],
          subTitle: errorMessages.imageUpload["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      // Group Error MEssages
      case 'group/error-update-group':
        this.alert = this.alertCtrl.create({
          title: errorMessages.groupUpdate["title"],
          subTitle: errorMessages.groupUpdate["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'group/error-leave-group':
        this.alert = this.alertCtrl.create({
          title: errorMessages.groupLeave["title"],
          subTitle: errorMessages.groupLeave["subTitle"],
          buttons: ['OK']
        }).present();
        break;
      case 'group/error-delete-group':
        this.alert = this.alertCtrl.create({
          title: errorMessages.groupDelete["title"],
          subTitle: errorMessages.groupDelete["subTitle"],
          buttons: ['OK']
        }).present();
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/alert.ts